import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import step_4 from "@/assets/integration-steps/meta/step_4.png";

interface Props {
  stepLabel?: string;
}

const MetaIntegrationStep4 = ({ stepLabel }: Props) => (
  <div className="channels-integration-step meta-step-4">
    <div className="step-label-row">
      {stepLabel && <OpticksNumberCircle number={stepLabel} />}
      <h6>Assign the audience to your Meta campaigns</h6>
    </div>
    <div className="step-label-row">
      <p>
        From that moment you will have a custom audience that will include the
        users that opticks has detected as fraudulents.
      </p>
    </div>
    <p>
      <b>This audience will be used as an exclusion</b> in the section of
      Audiences in your ad sets as you can see below.
    </p>
    <img src={step_4} alt="Screenshot of step 4 Meta Integration" />
  </div>
);

export default MetaIntegrationStep4;
